<template>
  <v-col cols="12" sm="12" md="12" class="mx-auto background">
    <v-row justify="center" align="center">
      <div class="py-10 px-10 container">
        <v-col v-if="!editMode">
          <v-row justify="center">
            <v-dialog
              v-model="deletingUser"
              v-if="deletingUser"
              width="500px"
              height="500px"
            >
              <v-col cols="12" sm="12" md="12">
                <v-row justify="center" align="center">
                  <div class="confirm-text">
                    Are you sure you want to delete this reason?
                  </div>
                  <v-btn
                    class="black--text mx-2 cancel-btn"
                    @click="deletingUser = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    class="white--text mx-2 delete-btn"
                    @click="deleteBlockReason()"
                  >
                    Delete
                  </v-btn>
                </v-row>
                <v-row> </v-row>
              </v-col>
            </v-dialog>
          </v-row>
          <v-row justify="start" align="center">
            <h5>Block Reason List</h5>
            <h6
              style="color: #55b6b2; cursor: pointer"
              class="mx-4"
              @click="
                editMode = true;
                selectedReason = null;
                reason = null;
              "
            >
              Create New
            </h6>
          </v-row>
          <v-row class="px-4 py-2">
            <v-col class="reasonList">
              <v-row
                v-for="item in reasons"
                :key="item"
                class="my-2"
                style="border-bottom: 2px solid lightgrey"
              >
                <v-col cols="10" class="px-0 py-0">
                  <h5>{{ item }}</h5>
                </v-col>
                <v-col
                  cols="2"
                  class="px-0 py-0"
                  v-if="item != 'Other' && item != 'other'"
                >
                  <v-icon
                    color="black"
                    @click="
                      selectedReason = item;
                      reason = item;
                      editMode = true;
                    "
                    >mdi-pencil</v-icon
                  >
                  <v-icon
                    color="black"
                    @click="
                      selectedReason = item;
                      deletingUser = true;
                    "
                    >mdi-delete</v-icon
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-btn
              v-if="!hideButtons"
              class="mx-2 cancel-btn2"
              @click="close()"
            >
              Close
            </v-btn>
          </v-row>
        </v-col>
        <v-col v-if="editMode">
          <v-row>
            <h5>{{ text }} Block Reason</h5>
          </v-row>
          <v-row>
            <v-text-field v-model="reason" solo outlined class="py-4">
            </v-text-field>
          </v-row>
          <v-row justify="center">
            <v-btn class="mx-2 cancel-btn2" @click="editMode = false">
              Cancel
            </v-btn>
            <v-btn
              v-if="reason"
              class="white--text mx-2 save-btn2"
              @click="editBlockReason()"
            >
              Save
            </v-btn>
          </v-row>
        </v-col>
      </div>
    </v-row>
  </v-col>
</template>

<script>
import Navbar from "@/components/Navbar";
import {
  collection,
  getDocs,
  getFirestore,
  where,
  setDoc,
  doc,
  query,
} from "firebase/firestore";
import { firebaseApp } from "../firebaseConfig";
const db = getFirestore(firebaseApp);

export default {
  name: "App",
  components: { Navbar },
  methods: {
    close() {
      this.$emit("close");
    },
    // Method to fetch all block reasons
    async getReasons() {
      console.log("Gettings reasons");
      let q = query(collection(db, "ban_reasons"));

      let tempReasons = [];

      const querySnapshot = await getDocs(q);
      await querySnapshot.forEach((doc) => {
        let tempReason = doc.data();

        this.docID = doc.id;

        tempReasons.push(tempReason);
        console.log("Temp Reason: ", tempReason);
      });

      this.reasons = tempReasons[0].reasonList;
    },
    // Method to delete a block reason
    async deleteBlockReason() {
      let tempReasonList = this.reasons;
      tempReasonList.splice(tempReasonList.indexOf(this.selectedReason), 1);

      let newObject = {
        reasonList: tempReasonList,
      };

      await setDoc(doc(db, "ban_reasons", this.docID), newObject)
        .then((res) => {
          console.log("Updating Ban Reasons Res: ", res);
          this.editMode = false;
          this.deletingUser = false;
          this.$store.commit("displayResponse", {
            type: "success",
            message: "Successfully updated ban reason list!",
          });
        })
        .catch((error) => {
          console.log("Updating Ban Reasons Error: ", error);
          this.$store.commit("displayResponse", {
            type: "error",
            message: "Unable to update the ban reason list, please try again!",
          });
        });
    },
    // Method to create/edit a block reason
    async editBlockReason(reason) {
      let tempReasonList = this.reasons;

      if (this.selectedReason) {
        tempReasonList[tempReasonList.indexOf(this.selectedReason)] =
          this.reason;
      } else {
        tempReasonList.push(this.reason);
      }

      let newObject = {
        reasonList: tempReasonList,
      };

      await setDoc(doc(db, "ban_reasons", this.docID), newObject)
        .then((res) => {
          console.log("Updating Ban Reasons Res: ", res);
          this.editMode = false;
          this.selectedReason = null;
          this.$store.commit("displayResponse", {
            type: "success",
            message: "Successfully updated ban reason list!",
          });
        })
        .catch((error) => {
          console.log("Updating Ban Reasons Error: ", error);
          this.$store.commit("displayResponse", {
            type: "error",
            message: "Unable to update the ban reason list, please try again!",
          });
        });
    },
  },
  data() {
    return {
      reasons: [],
      editMode: false,
      docID: null,
      reason: null,
      selectedReason: null,
      deletingUser: false,
    };
  },
  created() {
    this.getReasons();
  },
  props: {
    hideButtons: false,
  },
  computed: {
    text() {
      if (this.selectedReason) {
        return "Edit";
      } else {
        return "Create New";
      }
    },
  },
};
</script>

<style scoped>
.reasonList {
  max-height: 200px;
  overflow-y: scroll;
}

.background {
  background-color: white;
  width: 500px;
  border-radius: 24px;
}

.reasonList::-webkit-scrollbar {
  display: none;
}

.save-btn2 {
  background: linear-gradient(
    rgba(34, 193, 195, 1) 0%,
    rgba(0,129,128,255) 100%
  );
  border-radius: 20px;
  width: 40%;
}

.save-btn {
  box-shadow: 0px 0px 0px 1px black;
  border-radius: 20px;
  width: 40%;
}

.container {
  width: 90%;
  font-size: 18px;
  font-weight: bold;
  border-radius: 24px;
}

.confirm-text {
  background-color: white;
  width: 100%;
  height: 300px;
  font-size: 18px;
  font-weight: bold;
  padding: 20%;
}

.delete-btn {
  background: linear-gradient(
    0deg,
    rgba(34, 193, 195, 1) 0%,
    rgba(0,129,128,255) 100%
  );
  border-radius: 20px;
  width: 40%;
  margin-top: -15%;
}

.cancel-btn {
  box-shadow: 0px 0px 0px 1px black;
  border-radius: 20px;
  width: 40%;
  margin-top: -15%;
}

.cancel-btn2 {
  box-shadow: 0px 0px 0px 1px black;
  border-radius: 20px;
  width: 40%;
}
</style>